import React from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
  background: ${props => props.$background || '#0f172a'};
  color: ${props => props.$color || '#fff'};
  padding: 3.5vw 6vw;
  border: none;
  border-top-left-radius: 6vw;
  border-top-right-radius: 1vw;
  border-bottom-right-radius: 6vw;
  border-bottom-left-radius: 1vw;
  cursor: pointer;
  font-weight: 500;
  font-size: 3.8vw;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.15);
  transition: all 0.3s ease;
  font-family: Raleway, sans-serif;
  width: ${props => props.$fullWidth ? '100%' : 'auto'};
  min-width: 40vw;
  height: auto;
  min-height: 12vw;
  align-self: ${props => props.$alignSelf || 'flex-start'};
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  box-sizing: border-box;

  /* Tablet */
  @media (min-width: 768px) {
    padding: 2.5vw 5vw;
    font-size: 2.2vw;
    border-top-left-radius: 4vw;
    border-top-right-radius: 0.8vw;
    border-bottom-right-radius: 4vw;
    border-bottom-left-radius: 0.8vw;
    min-width: 30vw;
    min-height: 8vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    padding: 2px 25px;
    font-size: 15px;
    border-top-left-radius: 2.6042vw;
    border-top-right-radius: 0.2604vw;
    border-bottom-right-radius: 2.6042vw;
    border-bottom-left-radius: 0.2604vw;
    width: ${props => props.$fullWidth ? '100%' : '14.1354vw'};
    height: 3.6458vw;
    min-width: auto;
    min-height: auto;
  }

  &:hover {
    background: ${props => props.$hoverBackground || '#1e293b'};
    transform: translateY(-3px);
  }

  &:active {
    transform: translateY(-1px);
  }

  &:disabled {
    background: #cccccc;
    cursor: not-allowed;
    transform: none;
    
    &:hover {
      background: #cccccc;
      transform: none;
    }
  }
`;

const Button = ({ 
  children, 
  background, 
  color, 
  hoverBackground,
  fullWidth = false,
  alignSelf,
  disabled = false,
  ...props 
}) => {
  return (
    <StyledButton
      $background={background}
      $color={color}
      $hoverBackground={hoverBackground}
      $fullWidth={fullWidth}
      $alignSelf={alignSelf}
      disabled={disabled}
      {...props}
    >
      {children}
    </StyledButton>
  );
};

export default Button;